// import FingerprintJS from '@fingerprintjs/fingerprintjs';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import DefaultLayout from './layout/DefaultLayout';
import {
  CALLING_AGENT_DOWNLOAD_PATH,
  COSMOS_PATH,
  DIALER_DOWNLOAD_PATH,
  FIELD_AGENT_DOWNLOAD_PATH,
  LOGIN_PATH,
  UPDATE_EXTENSION_DEMO_PATH
} from './layout/Routes';
import Cosmos from './pages/cosmos/Cosmos';
import Login from './pages/auth/components/Login';
import { setDeviceIdInStore } from './reducers/commonSlice';
import { RootState } from './store';
import { triggerFingerprintJS } from './utils/FingerPrintJS';
import UpdateExtensionDemo from '@cp/pages/UpdateExtensionDemo';
import DownloadForFieldAgent from './pages/cosmos/DownloadForFieldAgent';
import DownloadForCallingAgent from './pages/cosmos/DownloadForCallingAgent';
import DownloadForDialer from './pages/cosmos/DownloadForDialer';

interface IProtectedRoute {
  children: JSX.Element;
}

export const getNextQueryParam = () => {
  const IS_NEW_BUILD = import.meta.env.VITE_BASE_URL;
  const { pathname, search, hash, href } = window.location;
  const newPath = IS_NEW_BUILD ? pathname.replace('/new', '') : pathname;
  if (href.includes('next')) return '';
  return encodeURIComponent(newPath + search + hash);
};

const ProtectedRoute: React.FC<IProtectedRoute> = props => {
  const { children } = props;
  const token = useSelector((store: RootState) => store?.common?.userData.token);
  if (!token) {
    return <Navigate to={`${LOGIN_PATH}?next=${getNextQueryParam()}`} replace />;
  }
  return children;
};

const AppRouter = () => {
  const deviceId = useSelector((store: RootState) => store?.common?.userData.deviceId);
  const dispatch = useDispatch();

  useEffect(() => {
    triggerFingerprintJS().then(newDeviceId => {
      dispatch(setDeviceIdInStore(newDeviceId));
    });
  }, [deviceId]);

  return (
    <Routes>
      <Route path={COSMOS_PATH} element={<Cosmos />} />
      <Route path={FIELD_AGENT_DOWNLOAD_PATH} element={<DownloadForFieldAgent />} />
      <Route path={CALLING_AGENT_DOWNLOAD_PATH} element={<DownloadForCallingAgent />} />
      <Route path={DIALER_DOWNLOAD_PATH} element={<DownloadForDialer />} />
      <Route path={LOGIN_PATH} element={<Login />} />
      <Route path={UPDATE_EXTENSION_DEMO_PATH} element={<UpdateExtensionDemo />} />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <DefaultLayout />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRouter;
